import { GhostIconButton, StatusTag } from "@certn/cascadia-react";
import { ActionListItem } from "@certn/cascadia";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";

export interface CheckRuleSetActionListItemProps {
  title: string;
  tag: "NOT_SET" | "SET";
  onPress: () => void;
}

export function CheckRuleSetActionListItem(
  props: CheckRuleSetActionListItemProps
) {
  const { t } = useTranslation();

  const { title, tag } = props;

  const getTag = {
    NOT_SET: (
      <StatusTag fill="background-accent-neutral-weak" statusInfoIcon={false}>
        {t("Not Set")}
      </StatusTag>
    ),
    SET: (
      <StatusTag fill="background-accent-green-weak" statusInfoIcon={false}>
        {t("Set")}
      </StatusTag>
    ),
  };

  return (
    <ActionListItem
      className={css({
        padding: "var(--space-6) var(--space-4) var(--space-6) var(--space-4)",
      })}
      title={title}
      tag={getTag[tag]}
      trailing={
        <GhostIconButton icon="chevron_right" onPress={props.onPress} />
      }
      testID={`check-rule-set-action-list-item-${title}`}
    />
  );
}
